export default class BPBeginnenSofortRequest {
  tischId: string
  identifier: string
  personen: number = 2
}
